"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexRGBColorDestination = void 0;
var tslib_1 = require("tslib");
var drawing_color_model_info_1 = require("../../../../../core/model/drawing/drawing-color-model-info");
var drawing_color_properties_destination_base_1 = require("./drawing-color-properties-destination-base");
var HexRGBColorDestination = (function (_super) {
    tslib_1.__extends(HexRGBColorDestination, _super);
    function HexRGBColorDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HexRGBColorDestination.prototype.setColorPropertyValue = function (reader) {
        this.colorModelInfo.rgb = drawing_color_model_info_1.DrawingColorModelInfo.sRgbToRgb(this.data.readerHelper.readAttribute(reader, 'val'));
    };
    return HexRGBColorDestination;
}(drawing_color_properties_destination_base_1.DrawingColorPropertiesDestinationBase));
exports.HexRGBColorDestination = HexRGBColorDestination;
